import { ReactComponent as IconInfo } from "@common_assets/svg/info-circle.svg"
import { IconButton, Tooltip } from "@mui/material"

export const focusRingSx = {
  "&:focus-visible": {
    outline: "2px solid",
    outlineColor: "mockup.primary60",
    outlineOffset: "2px",
  },
}

interface IInfoButtonProps {
  // Accessible name, e.g. "About Total"
  label: string
  info: string
}

// Small ⓘ that shows `info` on hover, focus or tap.
const InfoButton = ({ label, info }: IInfoButtonProps) => (
  <Tooltip title={info} describeChild enterTouchDelay={0}>
    <IconButton
      size="small"
      aria-label={label}
      sx={{
        p: 0.25,
        mr: 0.25,
        color: "mockup.neutral30",
        ...focusRingSx,
      }}
    >
      <IconInfo aria-hidden width={14} height={14} />
    </IconButton>
  </Tooltip>
)

export default InfoButton
